import { ArrowLeft, Compass } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { buttonVariants } from '@/components/ui';
import { routes } from '@/lib/routes';
import { usePageMeta } from '@/lib/seo';

export function NotFoundPage() {
  const { t } = useTranslation('common');
  usePageMeta({
    title: t('status.notFoundTitle'),
    description: t('status.notFoundBody'),
    noIndex: true,
  });
  return (
    <section className="not-found section-pad">
      <div className="container">
        <span>
          <Compass size={27} />
        </span>
        <p className="eyebrow">404</p>
        <h1>{t('status.notFoundTitle')}</h1>
        <p>{t('status.notFoundBody')}</p>
        <Link className={buttonVariants({ size: 'lg' })} to={routes.home}>
          <ArrowLeft className="rtl-flip" size={18} /> {t('actions.goHome')}
        </Link>
      </div>
    </section>
  );
}
